import React from 'react';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { getTileProps } from '../../mixins';
import { LoadingTileProps } from './tile.types';

const LoadingTile: React.FC<LoadingTileProps> = ({
  tileType = 'standard',
  className,
}) => {
  const tileProps = getTileProps(tileType);
  return (
    <div className={`${className} ${tileType}`}>
      <div className="loading">
        <LoadingSpinner />
      </div>
    </div>
  );
};

const StyledLoadingTile = styled(LoadingTile)`
  overflow: hidden;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  background: white;

  width: ${({ tileType }) => getTileProps(tileType).width};
  height: ${({ tileType }) => getTileProps(tileType).height};
  max-width: ${({ tileType }) => {
    if (tileType === 'tactical') {
      return '40.3rem';
    }
    return '100%';
  }};

  @media screen and (min-width: ${vars.breakPointSmallTablet}) {
    width: ${({ tileType }) => getTileProps(tileType).width};
    max-width: ${({ tileType }) => {
      if (tileType === 'tactical') {
        return '40.3rem';
      }
      return '23.2rem';
    }};
  }
  * {
    transition: ${vars.defaultTransition};
  }
  .loading {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    transition: none !important;
    height: 100%;
    transform: translateX(-50%);
    position: absolute;
    left: 50%;
    div,
    svg {
      transition: none !important;
      & * {
        transition: none !important;
      }
    }
  }

  &.listing {
    @media screen and (max-width: calc(${vars.breakPointSmallTablet} - 1px)) {
      .loading {
        height: auto;
        div {
          width: 100%;
          height: 50%;
        }
      }
    }
  }
`;

export default StyledLoadingTile;
